export default {"src":"/_next/static/media/ic-numberic-scale.199a639c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};